import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import moment from 'moment'
import {
  Container,
  Segment,
  Button,
  Form
} from 'semantic-ui-react'
import { isAuthAdmin, isLicenseAdmin } from '../utils'
import useAdminUser from '../hooks/useAdminUser'

const confirmDelete = (onRemove, noteId) => e => {
  if (window.confirm('Remove this note?')) {
    onRemove(noteId)
  }
}

const detectUrl = /(?!.*@)((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/gi;
const hasNoLeadingProtocol = /^(?!http|https)/i;

const linkBuilder = (url) => {
  const saneUrl = url && url.replace(hasNoLeadingProtocol, 'http://');
  return `<a href="${saneUrl}" target="_blank">${url}</a>`;
};

const noteLineMapper = (item, key) => {
  const urlsInItem = item.match(detectUrl);
  if (urlsInItem) {
    let content = item;
    urlsInItem.forEach((url) => {
      content = content.replace(url, linkBuilder(url));
    });
    return <div key={`note_line_${key}`} dangerouslySetInnerHTML={{ __html: content }}></div>;
  } else {
    return <div key={`note_line_${key}`}>{item}</div>;
  }
};

const NoteLines = ({ note }) => (
  <div style={{marginBottom: '1em'}}>
    {
      note
        .split('\n')
        .map(noteLineMapper)
    }
  </div>
);

NoteLines.propTypes = {
  note: PropTypes.string.isRequired
}

const Note = ({
  _id,
  adminUser,
  canRemove,
  createdOn,
  note,
  onRemove
}) => (
  <Segment compact>
    <div style={{borderBottom: '1px solid grey', display: 'inline-block', marginBottom: '1em'}}>
      <div style={{display: 'inline-block', paddingRight: '2em'}}><b>Created On</b> : {moment(createdOn).format('LL')}</div>
      <div style={{ display: 'inline-block', paddingRight: '2em' }}><b>Created by</b> : {adminUser.displayname}</div>
    </div>
    <NoteLines note={note} />
    {
      canRemove ? <Button negative content='remove' size='mini' onClick={confirmDelete(onRemove, _id)} /> : null
    }
  </Segment>
)

Note.propTypes = {
  _id: PropTypes.string.isRequired,
  adminUser: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    displayname: PropTypes.string.isRequired
  }).isRequired,
  canRemove: PropTypes.bool.isRequired,
  createdOn: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]).isRequired,
  note: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired
}

class AddNote extends React.PureComponent {
  state = {
    note: this.props.note || '',
    dirty: false,
    showing: false
  }

  onCancel = (e) => {
    e.preventDefault()
    this.setState({
      note: this.props.note || '',
      dirty: false,
      showing: false
    })
  }

  onNoteChange = (e, data) => this.setState({
    note: data.value,
    dirty: true
  })

  onSubmit = (e) => {
    e.preventDefault()
    if (this.props.onAddNote) {
      this.props.onAddNote(this.state.note)
      this.setState({dirty: false, showing: false, note: ''})
    }
  }

  setShowing = () => this.setState({showing: true})

  showAddNoteButton = () => (<Button onClick={this.setShowing}>Add Note</Button>)

  showAddNoteForm = () => {
    return (
      <Segment>
        <Form widths='equal' size='tiny' onSubmit={this.onProfileSubmit}>
          <Form.Group>
            <Form.TextArea
              width={6}
              label='Note'
              name='note'
              placeholder='Note'
              rows={3}
              value={this.state.note}
              onChange={this.onNoteChange}
            />
          </Form.Group>
          <Button.Group>
            <Button onClick={this.onCancel}>Cancel</Button>
            <Button.Or />
            <Button positive={this.state.dirty} disabled={!this.state.dirty} onClick={this.onSubmit}>Save</Button>
          </Button.Group>
        </Form>
      </Segment>
    )
  }
  render = () => this.state.showing ? this.showAddNoteForm() : this.showAddNoteButton()
}
AddNote.propTypes = {
  note: PropTypes.string.isRequired,
  onAddNote: PropTypes.func.isRequired
}
const Notes = ({
  notes = [],
  onAddNote,
  onRemoveNote
}) => {

  const adminUser = useAdminUser();

  return (
    <Container fluid>
      {
        isAuthAdmin(adminUser) || isLicenseAdmin(adminUser) ? <AddNote onAddNote={onAddNote} note='' /> : null
      }
      { notes.length ? (
        <Segment.Group>
          {notes.map(n => (<Note
            key={'note_' + R.prop('_id', n)}
            _id={R.prop('_id', n)}
            note={R.prop('note', n)}
            createdOn={R.prop('created_on', n)}
            adminUser={R.prop('created_by', n)}
            onRemove={onRemoveNote}
            canRemove={isAuthAdmin(adminUser)}
          />))}
        </Segment.Group>
      ) : null }
    </Container>
  );
}

Notes.propTypes = {
  notes: PropTypes.array.isRequired,
  onRemoveNote: PropTypes.func.isRequired,
  onAddNote: PropTypes.func.isRequired
}

export default Notes



// WEBPACK FOOTER //
// ./webAdmin/views/notes.js